import { motion } from 'framer-motion'
import { Badge, Tag } from './ui'
import { useI18n } from '../lib/i18n'
import { useAutoDemo } from '../lib/auto-demo'

export function Hero() {
  const { t } = useI18n()
  const h = t.demoHero
  const autoDemo = useAutoDemo()
  // LTR-only for now; will flip automatically via document.dir when an
  // RTL language is re-introduced.
  const arrow =
    typeof document !== 'undefined' && document.documentElement.dir === 'rtl' ? '←' : '→'
  return (
    <section
      data-demo-target="hero"
      className="relative mx-auto max-w-6xl px-6 sm:px-10 pt-16 sm:pt-24 pb-12 sm:pb-20"
    >
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="flex flex-col gap-6 max-w-4xl"
      >
        <div className="flex items-center gap-3 justify-between flex-wrap">
          <Tag kind="rule">{h.tag}</Tag>
          <button
            type="button"
            onClick={() => (autoDemo.isActive ? autoDemo.stop() : autoDemo.start())}
            className="mono text-[length:var(--text-micro)] uppercase tracking-widest px-3 py-1.5 rounded-[var(--radius-sm)] border transition-colors"
            style={
              autoDemo.isActive
                ? {
                    background: 'oklch(72% 0.22 340)',
                    borderColor: 'oklch(72% 0.22 340)',
                    color: 'oklch(15% 0.02 280)',
                  }
                : {
                    background: 'oklch(72% 0.22 340 / 0.12)',
                    borderColor: 'oklch(72% 0.22 340 / 0.55)',
                    color: 'oklch(82% 0.18 340)',
                  }
            }
          >
            {autoDemo.isActive ? '■ Stop auto demo' : '▶ Play auto demo'}
          </button>
        </div>

        <h1
          className="text-[color:var(--color-orion-text)] leading-[1.05]"
          style={{ fontSize: 'var(--text-h1)', fontWeight: 600 }}
        >
          {h.titleLine1}
          <br />
          <span className="text-[color:var(--color-orion-amber)]">{h.titleLine2}</span>
        </h1>

        <div
          className="space-y-3 text-[color:var(--color-orion-haze)]"
          style={{ lineHeight: 1.6 }}
        >
          <p
            className="whitespace-nowrap overflow-x-auto"
            style={{ fontSize: 'var(--text-body)' }}
          >
            <span className="mono text-[color:var(--color-orion-text)]">{h.para1.midA}</span>
            {' '}{arrow}{' '}
            <span className="mono text-[color:var(--color-orion-text)]">{h.para1.midB}</span>
            {' '}{arrow}{' '}
            <span className="mono text-[color:var(--color-orion-amber)]">{h.para1.midC}</span>
            {h.para1.arrowAfter}
          </p>
          <p className="max-w-3xl" style={{ fontSize: 'var(--text-lead)' }}>
            {h.para2.lead}
            <span className="text-[color:var(--color-orion-text)]">{h.para2.spanA}</span>
            {h.para2.tail}
          </p>
        </div>
      </motion.div>

      {/* 故事钩 */}
      <motion.div
        data-demo-target="hero-story"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        className="mt-20 surface-night border-faint rounded-[var(--radius-lg)] p-6 sm:p-8 max-w-3xl"
      >
        <div className="flex items-center gap-2 mb-3 flex-wrap">
          <Badge tone="block" dot>
            {h.storyCard.alertTag}
          </Badge>
          <span className="mono text-[length:var(--text-small)] text-[color:var(--color-orion-haze)]">
            {h.storyCard.alertMeta}
          </span>
        </div>
        <p
          className="text-[color:var(--color-orion-text)]"
          style={{ fontSize: 'var(--text-lead)', lineHeight: 1.6 }}
        >
          {h.storyCard.body}
          <br />
          <span className="text-[color:var(--color-orion-haze)]">{h.storyCard.bodyHaze}</span>
        </p>
      </motion.div>
    </section>
  )
}
